import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { GroupTypes, Services } from "@/components/landing/Sections1";
import { Destinations, Adventures } from "@/components/landing/Sections2";
import { WhyUs, HowItWorks } from "@/components/landing/Sections3";
import { TripBuilder } from "@/components/landing/TripBuilder";
import { Stories, Gallery, Trust } from "@/components/landing/Sections4";
import { Reviews } from "@/components/landing/Reviews";
import { FAQ, FinalCTA, Footer } from "@/components/landing/Sections5";
import { WhatsAppFloat, MobileStickyCTA, ConversionWidgets } from "@/components/landing/Conversion";
import { PackageHighlights, BestSpotlight } from "@/components/landing/PackageShowcase";
import { ReelsSection } from "@/components/landing/ReelsSection";

export default function LandingPage() {
    return (
        <div className="bg-cream min-h-screen pb-14 md:pb-0" data-testid="landing-page">
            <Header />
            <main>
                <Hero />
                <BestSpotlight />
                <PackageHighlights />
                <ReelsSection />
                <GroupTypes />
                <Services />
                <Destinations />
                <Adventures />
                <WhyUs />
                <HowItWorks />
                <TripBuilder />
                <Stories />
                <Reviews />
                <Gallery />
                <Trust />
                <FAQ />
                <FinalCTA />
            </main>
            <Footer />
            <WhatsAppFloat />
            <MobileStickyCTA />
            <ConversionWidgets />
        </div>
    );
}
